import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/img/products/whistle-low-d-lead.jpg'


const _hoisted_1 = {
  class: "whistles-detail",
  style: {"margin-top":"6em","margin-bottom":"4em"}
}
const _hoisted_2 = {
  class: "container",
  style: {"max-width":"880px"}
}
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = { class: "table table-striped align-middle" }
const _hoisted_5 = {
  scope: "row",
  class: "fw-normal"
}
const _hoisted_6 = { class: "text-end" }
const _hoisted_7 = { class: "text-end" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-muted mb-5" }
const _hoisted_10 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CitesInfoComponent = _resolveComponent("CitesInfoComponent")!
  const _component_LinkComponent = _resolveComponent("LinkComponent")!
  const _component_ImageCarouselComponent = _resolveComponent("ImageCarouselComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[8] || (_cache[8] = _createStaticVNode("<h1 class=\"text-center mb-3\" data-v-74839f30>whistles</h1><p class=\"text-center text-muted mb-4\" data-v-74839f30> Whistles are where ironwood began, and I still build them on request — in wood, aluminium and brass, tuned in just intonation, in every key. </p><img src=\"" + _imports_0 + "\" class=\"w-100 rounded mb-5\" alt=\"A low D whistle in panacoco wood with aluminium sections\" data-v-74839f30><h2 class=\"mb-3\" data-v-74839f30>Features</h2><ul class=\"feature-list mb-5\" data-v-74839f30><li data-v-74839f30> Thin-walled wooden whistles — a wall of about 1.5 mm, unless it is a very large whistle. </li><li data-v-74839f30> Tunable, with a cork-sealed joint. On wooden whistles the mouthpiece is protected with an aluminium shell. </li><li data-v-74839f30>Tuned in just or equal intonation.</li><li data-v-74839f30>Available in every key.</li><li data-v-74839f30> Oval tone holes on request (instead of round) — for better half-holing and easier covering on larger whistles. </li><li data-v-74839f30>Offset G and/or E holes on request.</li></ul><h2 class=\"mb-3\" data-v-74839f30>Materials</h2>", 6)),
      _createElementVNode("p", _hoisted_3, [
        _cache[0] || (_cache[0] = _createElementVNode("b", null, "Wood.", -1)),
        _cache[1] || (_cache[1] = _createTextVNode(" Different hardwoods, from boxwood to grenadilla and more exotic sorts", -1)),
        _createVNode(_component_CitesInfoComponent),
        _cache[2] || (_cache[2] = _createTextVNode(" There may be a surcharge for certain kinds of wood. The walls are very thin, and aluminium is used for the joint. ", -1))
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("p", { class: "mb-3" }, [
        _createElementVNode("b", null, "Aluminium."),
        _createTextVNode(" Made from the aluminium alloy EN AW 6060, which is suitable for kitchen utensils; the mouthpiece solder is lead-free. Tunable with a cork-sealed joint, with walls as thin as technically possible for a jointed whistle. ")
      ], -1)),
      _cache[10] || (_cache[10] = _createElementVNode("p", { class: "mb-5" }, [
        _createElementVNode("b", null, "Brass."),
        _createTextVNode(" A lead-free brass alloy with a hardwood fipple, tunable with a cork-sealed joint. Pure brass whistles can be made by arrangement but they'll be quite heavy. ")
      ], -1)),
      _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "mb-3" }, "Prices", -1)),
      _createElementVNode("p", null, [
        _cache[3] || (_cache[3] = _createTextVNode(" There is no online shop here — to order, just ", -1)),
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "contact me"
        }),
        _cache[4] || (_cache[4] = _createTextVNode(". ", -1))
      ]),
      _cache[12] || (_cache[12] = _createElementVNode("p", { class: "mb-2" }, [
        _createTextVNode(" Prices are for a standard whistle, where I decide on tube diameter, wall thickness, hole size and position. I make whistles in "),
        _createElementVNode("b", null, "all keys"),
        _createTextVNode(" — the table lists a selection. ")
      ], -1)),
      _createElementVNode("table", _hoisted_4, [
        _cache[5] || (_cache[5] = _createElementVNode("thead", null, [
          _createElementVNode("tr", { class: "table-dark" }, [
            _createElementVNode("th", { scope: "col" }, "Key"),
            _createElementVNode("th", {
              scope: "col",
              class: "text-end"
            }, "Aluminium"),
            _createElementVNode("th", {
              scope: "col",
              class: "text-end"
            }, "Brass / Wood"),
            _createElementVNode("th", {
              scope: "col",
              class: "text-end"
            }, "Wood*")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.standardItems, (item) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: item.key,
              class: _normalizeClass(item.class)
            }, [
              _createElementVNode("th", _hoisted_5, _toDisplayString(item.key), 1),
              _createElementVNode("td", _hoisted_6, _toDisplayString(item.alu) + " €", 1),
              _createElementVNode("td", _hoisted_7, _toDisplayString(item.brass) + " €", 1),
              _createElementVNode("td", _hoisted_8, _toDisplayString(item.wood) + " €", 1)
            ], 2))
          }), 128))
        ])
      ]),
      _cache[13] || (_cache[13] = _createElementVNode("p", null, "* For certain types of wood they might be a surcharge.", -1)),
      _createElementVNode("p", _hoisted_9, [
        _cache[6] || (_cache[6] = _createTextVNode(" For a custom whistle with your own ideas and wishes, just ", -1)),
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "contact me"
        }),
        _cache[7] || (_cache[7] = _createTextVNode(". ", -1))
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "mb-3" }, "Gallery", -1)),
      _createVNode(_component_ImageCarouselComponent, {
        id: "whistleGallery",
        images: _ctx.galleryImages,
        class: "mb-5"
      }, null, 8, ["images"]),
      _createElementVNode("p", _hoisted_10, [
        _createVNode(_component_LinkComponent, {
          href: "/#contact",
          "link-text": "Contact me about a whistle"
        })
      ])
    ])
  ]))
}